import React from 'react';
import AddPractitionerSheet from './AddPractitionerSheet';
import { Practitioner } from '@/lib/types';

interface EditPractitionerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  practitioner: Practitioner | null;
  clinicId: string;
  onPractitionerUpdated: (practitioner: any) => void;
}

const EditPractitionerSheet = ({ 
  open, 
  onOpenChange, 
  practitioner, 
  clinicId,
  onPractitionerUpdated 
}: EditPractitionerSheetProps) => {
  if (!practitioner) return null;

  return (
    <AddPractitionerSheet
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onPractitionerUpdated}
      clinicId={clinicId}
      practitionerId={practitioner.id}
      isEdit={true}
    />
  );
};

export default EditPractitionerSheet;
